import { Box, Image, Text } from '@betty/moonlight';
import BoxGradient from '@betty/moonlight/lib/common/Box/variants/BoxGradient/BoxGradient';
import React, { memo, useCallback, useMemo } from 'react';
import { InboxMessageResponse, InboxMessageType } from '../state';
import { inboxMessageIconMap } from '../content/inbox.content';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { Pressable } from 'react-native';
import { getFromNowDateText } from '@betty/toolkit/utils';

function InboxMessageItem({
  type,
  isRead,
  title,
  body,
  cta,
  createdAt,
}: InboxMessageResponse) {
  const imageName = useMemo(
    // TODO: Remove as casting when integrating Smartico messages
    () => inboxMessageIconMap[type as InboxMessageType],
    [type],
  );

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleCTA = useCallback(() => {
    navigation.popToTop();

    switch (cta.type) {
      case 'NavigationRewards':
      case 'RedeemLoyaltyReward':
        return navigation.navigate('Rewards');
      case 'NavigationShop':
        return navigation.navigate('Shop');
      case 'NavigationGames':
        return navigation.navigate('MainTabNavigator', { screen: 'Games' });
      case 'NavigationPromotions':
        return navigation.navigate('Promos');
      case 'RedeemCommunityEventReward':
        return navigation.navigate('CommunityJackpot');
      default:
        return;
    }
  }, [cta.type, navigation]);

  return (
    <Pressable onPress={handleCTA}>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap="space-400"
        backgroundColor="primaryBackground"
        paddingHorizontal="space-600"
        paddingVertical="space-400"
      >
        <Image width="space-1000" height="space-1000" name={imageName} />
        <Box display="flex" flex={1}>
          <Text
            variant="body-m-semi"
            marginBottom="space-100"
            color="darkSurfacePrimary"
          >
            {title}
          </Text>
          <Text variant="body-s" color="darkSurfacePrimary">
            {body}
            {cta.text ? (
              <>
                {' '}
                <Text variant="link-small">{cta.text}</Text>
              </>
            ) : null}
          </Text>
          <Text variant="body-s" color="darkSurfaceMuted">
            {getFromNowDateText(createdAt)}
          </Text>
        </Box>
        <BoxGradient
          opacity={isRead ? 0 : 1}
          width={12}
          height={12}
          gradient="attentionBackground"
          borderRadius="radius-full"
        />
      </Box>
    </Pressable>
  );
}

export default memo(InboxMessageItem);
